

<div *ngIf="!this.loading">
<mat-spinner></mat-spinner>
</div>
<div *ngIf="this.loading">


  <div class="row">
    <div class="col-11"></div>
    <div class="col text-end">
      <button mat-mini-fab [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="row" style="margin-top: 10px;">
      <mat-card>

        <mat-card-content>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">

              <table class="margi">
                <tr>
                  <th>Service Name:</th>
                  <td>{{responseData?.partyService?.SERVICE_NAME}}</td>
                </tr>
                <tr>
                  <th>Service Code: </th>
                  <td>{{responseData?.partyService?.SERVICE_CODE}} </td>
                </tr>
                <tr>
                  <th>Region: </th>
                  <td>{{
                    responseData?.partyService!.SERVICE_PROVIDERS[0]!.PARTY_ROLES!.PARTy.ORGANIZATIONS[0].REGIONS[0]!.CODE
                    }} -
                    {{
                    responseData?.partyService!.SERVICE_PROVIDERS[0]!.PARTY_ROLES!.PARTy.ORGANIZATIONS[0].REGIONS[0]!.NAME
                    }}
                  </td>


                </tr>
                <tr>
                  <th>Federal Category: </th>
                  <td>
                    {{responseData?.partyService!.PARTY_SERVICE_TYPES[0]!.SERVICE_TYPES.TYPE}}
                  </td>
                </tr>
                <tr>
                  <th>Measurable Program Objective: </th>
                  <td>{{responseData?.partyService?.MEASURABLE_PROGRAM_OBJECTIVES?.NAME}} </td>
                </tr>
                <tr>
                  <th>SSDP Components: </th>
                  <td>
                    @for(item of this.responseData?.partyService!.SSDP_COMPONENTS; track item){
                    {{item?.NAME}}
                    @if(!$last){
                    <br>
                    }

                    }
                  </td>
                </tr>
                <tr>
                  <th>Service Hours: </th>
                  <td>
                    {{responseData?.partyService?.SERVICE_HOURS?.NAME}}
                  </td>
                </tr>
                <tr>
                  <th>Federal Sub Category: </th>
                  <td>
                    @if(responseData?.partyService!.PARTY_SERVICE_TYPES[0]!.SERVICE_TYPES.TYPE){
                    {{responseData?.partyService!.PARTY_SERVICE_TYPES[0]!.SERVICE_TYPES.TYPE}}
                    }
                    @else{
                    N/A
                    }
                    {{responseData?.partyService!.PARTY_SERVICE_TYPES[0]!.SERVICE_TYPES.TYPE}}</td>
                </tr>
                <tr>
                  <th>State Code: </th>
                  <td> {{responseData?.partyService?.FEDERAL_CODES?.CODE}} </td>
                </tr>
                <tr>
                  <th>Service Category: </th>
                  <td> {{responseData?.partyService!.SERVICE_CATEGORIES[0].CATEGORY}}</td>
                </tr>
                <tr>
                  <th>Provided By: </th>
                  <td> {{responseData?.partyService?.PARTY_SERVICE_PROVIDERS?.NAME}} </td>
                </tr>
                <tr>
                  <th>Grade Range:</th>
                  <td>
                    @for(grade of responseData?.partyService?.GRADES; track grade){
                    {{grade.GRADES}}
                    @if(!$last){
                    ,
                    }
                    }
                  </td>
                </tr>
                <tr>
                  <th>Service Period: </th>
                  <td>
                    @for(period of responseData?.partyService?.ENROLLMENT_PERIODS;track period){
                    {{period.PERIOD}}
                    @if(!$last){
                    <br>
                    }
                    }

                  </td>
                </tr>
                <tr>
                  <th>Status: </th>
                  <td>
                    @if(responseData?.partyService?.PARTY_SERVICE_STATUS_TYPES_ID === 1){
                      <div class="success">Active</div> 
                    }
                    @else {
                      <div class="danger">
                      Inactive
                      </div>
                    }
                  </td>
                </tr>

              </table>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">

              {{responseData?.partyService?.DESCRIPTION}}

            </div>
          </div>
        </mat-card-content>

      </mat-card>
  </div>    
</div>
